import { render, staticRenderFns } from "./NoteViewContainer.vue?vue&type=template&id=5ab9e827&scoped=true"
import script from "./NoteViewContainer.vue?vue&type=script&lang=js"
export * from "./NoteViewContainer.vue?vue&type=script&lang=js"
import style0 from "./NoteViewContainer.vue?vue&type=style&index=0&id=5ab9e827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9e827",
  null
  
)

export default component.exports